import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const mainBackendURL = import.meta.env.VITE_SERVER_URL;
export const historyBackendURL = import.meta.env.VITE_SERVER_HISTORY_URL;

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: historyBackendURL ?? mainBackendURL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as { persistValues: { userToken: string } };
      const token = state.persistValues.userToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Balance'],
  endpoints: () => ({}),
});
